import React, { useContext } from "react";
import { UserContext } from "../../context/userContext";
import AnonymousSection from "./anonymous";
import AuthenticatedSection from "./authenticated";
import {
  CancelApplicationContextProvider,
  CancellationCase,
} from "../../context/cancelApplicationContext";
import { ApplicationFlows } from "./authenticated/application-flow/types";

export default function Index(): React.JSX.Element {
  const { email } = useContext(UserContext);

  return email ? (
    // cancellation context is deeper in the tree for the Authenticated section,
    // because the flow resolution happens deeper in the hierarchy
    <AuthenticatedSection />
  ) : (
    <CancelApplicationContextProvider
      cancellationCase={CancellationCase.NOT_PERSISTED}
      applicationFlow={ApplicationFlows.ANONYMOUS}
    >
      <AnonymousSection />
    </CancelApplicationContextProvider>
  );
}
